/**
 * Build version info, injected at build time via Vite `define`
 * (see vite.config.ts). Falls back gracefully in dev / tests where
 * the defines may be absent.
 */
declare const __APP_VERSION__: string | undefined;
declare const __GIT_SHA__: string | undefined;
declare const __BUILD_TIME__: string | undefined;

function readDefine(name: string): string | undefined {
  try {
    if (name === "__APP_VERSION__" && typeof __APP_VERSION__ !== "undefined") return __APP_VERSION__;
    if (name === "__GIT_SHA__" && typeof __GIT_SHA__ !== "undefined") return __GIT_SHA__;
    if (name === "__BUILD_TIME__" && typeof __BUILD_TIME__ !== "undefined") return __BUILD_TIME__;
  } catch {
    /* define not present (vitest / unbuilt dev) */
  }
  return undefined;
}

export const APP_VERSION = readDefine("__APP_VERSION__") ?? "0.1.0-dev";
export const GIT_SHA = readDefine("__GIT_SHA__") ?? "unknown";
export const BUILD_TIME = readDefine("__BUILD_TIME__") ?? "dev";

export function versionLabel(): string {
  return `v${APP_VERSION}+${GIT_SHA}`;
}
